import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, IconButton, Typography } from '@mui/material';
import {
  downloadSourcePageRange,
  formatSourceBatesLabel,
  formatSourcePageLabel,
  getSourceJumpPage,
  isPdfSourceFileName,
} from './SourceUtils.js';

const iconButtonSx = {
  padding: '2px',
  visibility: 'hidden',
  opacity: 0,
  transition: 'opacity 0.2s, visibility 0.2s',
  '&:hover': {
    opacity: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
};

/**
 * Filename (+ optional page/Bates labels) with hover VisibilityIcon and,
 * when a page label is shown on a PDF source, a page-range DownloadIcon.
 */
export default function SourceLink({
  caseId,
  fileName,
  documentKey,
  source,
  setDisplayedDocument,
  displayFileName,
}) {
  const labelFileName = displayFileName ?? fileName ?? source?.filename ?? '';
  const pageLabel = formatSourcePageLabel(source);
  const showDownload = Boolean(pageLabel) && Boolean(caseId) && Boolean(fileName) && isPdfSourceFileName(fileName);

  const openDocument = (e) => {
    e.stopPropagation();
    setDisplayedDocument({
      key: documentKey,
      page: getSourceJumpPage(source),
    });
  };

  const downloadPages = (e) => {
    e.stopPropagation();
    downloadSourcePageRange(caseId, fileName, source);
  };

  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.5 }}>
      <Typography
        component="span"
        title="Click to view source document"
        sx={{
          cursor: 'pointer',
          textDecoration: 'underline',
          fontSize: '0.9rem',
        }}
        onClick={openDocument}
      >
        {labelFileName} {pageLabel}{formatSourceBatesLabel(source)}
      </Typography>
      <IconButton
        className="source-view-icon"
        size="small"
        onClick={openDocument}
        sx={iconButtonSx}
        title="Click to view source document"
      >
        <VisibilityIcon />
      </IconButton>
      {showDownload && (
        <IconButton
          className="source-view-icon"
          size="small"
          onClick={downloadPages}
          sx={iconButtonSx}
          title="Download cited pages as PDF"
        >
          <DownloadIcon />
        </IconButton>
      )}
    </Box>
  );
}
